import { createContext } from 'react';

/** True when a page renders inside the main shell (Top Bar + Bottom Bar) — i.e. a page *inside* "আরও" (Bible 13.1 rule 4). */
export const InnerCtx = createContext(false);

/** The pages that live inside the "আরও" menu itself. Their Bottom Bar keeps "আরও" active; detail/form pages below them are sub-pages (Back only). */
export const MORE_INNER_PATHS = ['/more', '/customers', '/invoices', '/khata', '/expenses', '/stock/investment', '/vendors', '/profit', '/insights', '/zakat', '/reports', '/notes', '/import', '/sms', '/review', '/settings', '/help', '/recycle'] as const;
export const isMoreInner = (pathname: string): boolean => MORE_INNER_PATHS.includes(pathname.replace(/\/+$/, '') as never);
